import React, { useState, useEffect } from 'react';

interface HilCountdownProps {
  expiresAt: string;
  onExpired?: () => void;
}

function formatTime(seconds: number): string {
  if (seconds <= 0) return '00:00';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function HilCountdown({ expiresAt, onExpired }: HilCountdownProps): React.JSX.Element {
  const [remaining, setRemaining] = useState(() => {
    const diff = Math.floor((new Date(expiresAt).getTime() - Date.now()) / 1000);
    return Math.max(0, diff);
  });

  useEffect(() => {
    if (remaining <= 0) {
      onExpired?.();
      return;
    }
    const id = setInterval(() => {
      setRemaining((prev) => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(id);
          onExpired?.();
          return 0;
        }
        return next;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [expiresAt, onExpired]);

  const cls =
    remaining <= 60 ? 'hil-countdown hil-countdown--danger'
    : remaining <= 300 ? 'hil-countdown hil-countdown--warning'
    : 'hil-countdown';

  return <span className={cls}>{formatTime(remaining)}</span>;
}
